export default __webpack_public_path__ + "static/media/delete.83f4b93d.png";